var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFutures({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.34131,
    y: 4.69824,
    width: 11.9176,
    height: 15.5231,
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinejoin: "bevel"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.34106 13.835H4.18066V16.0607C4.18066 18.3585 6.04334 20.2211 8.34106 20.2211V20.2211",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinejoin: "bevel"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9546 12.1832L14.2999 9.83789L16.6452 12.1832",
    stroke: "currentColor",
    strokeWidth: 1.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3003 10.2861V15.0822",
    stroke: "currentColor",
    strokeWidth: 1.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFutures);
export default __webpack_public_path__ + "static/media/futures.6342b186a60f404bce4f71e8d65958a2.svg";
export { ForwardRef as ReactComponent };